import React from 'react';
import "./styles.scss";

const ResetAllButton = ({ handleClick, label='Reset All' }) => {
    return <span className='reset-all-button' onClick={() => handleClick()}>
        <p>{label}</p>
    </span>
}

export default ResetAllButton;